<template>
  <FullScreenMap v-slot="{ fullScreen }">
    <Box :aspect="0.4" class="map-container mb-15" :class="{ '!h-screen !w-screen': fullScreen }">
      <ShowLocationMap
        :points="points"
        :show-info="true"
        :hide-inner-circle="true"
      >
        <template #info="{ point }">
          <h6>{{ point.name }}</h6>
          {{ $t('pages.visibility.location.map.infoWindowText') + point.name }}
        </template>
      </ShowLocationMap>
    </Box>
  </FullScreenMap>
</template>

<script lang="ts" setup>
import Box from '@utils/Box.vue';
import {
  computed,
} from 'vue';
import ShowLocationMap from '@utils/maps/ShowLocationMap.vue';
import FullScreenMap from '@utils/FullScreenMap.vue';
import type { VisibilityLocation } from '@/entities/Entities';

interface Props {
  points?: VisibilityLocation[];
}

const props = defineProps<Props>();
const points = computed(() => props.points?.map((point) => ({
  id: point.id,
  gisLocation: point.gisLocation,
  radius: 50,
  name: point.name,
})));
</script>
